import React from 'react';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { withRouter } from 'react-router-dom';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { useSelector, useDispatch } from 'react-redux';
import { pushShowRecommendationTab } from '../../slices/recommendationTableSlice';
import { pushSelectedApplication } from '../../slices/HeatMapSlice';
import { pushSelectedAccount, pushClickEvent, pushEnvClickEvent } from '../../slices/ApplicationDrillHeatMapSlice';
import { pushShowApply, pushRestrictValue, pushConditionalTab } from '../../slices/ButtonsSlice';
import { deleteChipArrayAddCriteria, pushSelectedChipArray, pushClearFilterArray, pushShowCard, pushApplyEvent, pushCancelEvent } from '../../slices/RiskFilterSlice';
import { pushRiskTableData, pushTableData } from '../../slices/recommendationTableSlice';
import { pushAccountWiseHeatMap } from '../../slices/ApplicationDrillHeatMapSlice';
import { pushOverallHeatMap } from '../../slices/HeatMapSlice';
import { makeStyles } from '@material-ui/core';
import StyledLink from './BreadCrumbStyles';
const useStyles = makeStyles({
  separator: {
    color: '#141414'
  },
  breadcrumbs: {
    cursor: 'pointer',
    paddingLeft: '21px',
    marginTop: '4px'
  }
});

const RecommendationBreadCrumbs = props => {
  const classes = useStyles();
  const accountWiseApiResponseData = useSelector(state => state.recommendationTable.applicationDrillHeatmap);
  const riskApiResponseData = useSelector(state => state.recommendationTable.riskResponse);
  const apiResponseData = useSelector(state => state.recommendationTable.dashboardResponse);
  let clearAllRecoTable = [];

  if (apiResponseData && apiResponseData.data) {
    clearAllRecoTable = apiResponseData.data.responseList;
  }

  let clearAllDataOrigin = [];

  if (riskApiResponseData?.data?.responseList) {
    clearAllDataOrigin = riskApiResponseData.data.responseList;
  }

  let drillFilterData = [];

  if (accountWiseApiResponseData && accountWiseApiResponseData.data) {
    drillFilterData = accountWiseApiResponseData.data.responseList;
  }

  const selectedApplication = useSelector(state => state.heatMapSlice.selectedApplication);
  const selectedAccount = useSelector(state => state.applicationDrillHeatMap.selectedAccount);
  const dispatch = useDispatch();
  const {
    history
  } = props;
  return /*#__PURE__*/React.createElement(Breadcrumbs, {
    separator: /*#__PURE__*/React.createElement(NavigateNextIcon, {
      fontSize: "small",
      className: classes.separator
    }),
    "aria-label": "breadcrumb",
    style: {
      cursor: 'pointer'
    },
    className: classes.breadcrumbs
  }, /*#__PURE__*/React.createElement(StyledLink, {
    color: "initial",
    onClick: () => {
      history.push('/analytics');
      dispatch(pushShowRecommendationTab(false));
      dispatch(pushShowApply(false));
      dispatch(pushClickEvent(false));
      dispatch(deleteChipArrayAddCriteria([]));
      dispatch(pushSelectedChipArray([]));
      dispatch(pushClearFilterArray([]));
      dispatch(pushOverallHeatMap(clearAllDataOrigin));
      dispatch(pushRiskTableData(clearAllDataOrigin));
      dispatch(pushShowCard(false));
      dispatch(pushEnvClickEvent(false));
      dispatch(pushConditionalTab(true));
      dispatch(pushTableData(clearAllRecoTable));
    }
  }, "Risk Analytics"), /*#__PURE__*/React.createElement(StyledLink, {
    color: "initial",
    onClick: () => {
      history.push(`/analytics/applications/${props.match.params.appId}`);
      dispatch(pushSelectedApplication(selectedApplication));
      dispatch(deleteChipArrayAddCriteria([]));
      dispatch(pushSelectedChipArray([]));
      dispatch(pushClearFilterArray([]));
      dispatch(pushAccountWiseHeatMap(drillFilterData));
      dispatch(pushRiskTableData(drillFilterData));
      dispatch(pushShowCard(false));
      dispatch(pushRestrictValue(false));
      dispatch(pushCancelEvent(false));
      dispatch(pushApplyEvent(false));
      dispatch(pushEnvClickEvent(false));
      dispatch(pushConditionalTab(true));
    }
  }, selectedApplication), accountWiseApiResponseData && accountWiseApiResponseData.data ? /*#__PURE__*/React.createElement(StyledLink, {
    color: "initial",
    onClick: () => {
      history.push(`/analytics/environments/${props.match.params.appId}/${props.match.params.accountUuid}`);
      dispatch(pushSelectedAccount(selectedAccount));
      dispatch(pushSelectedApplication(selectedApplication));
      dispatch(deleteChipArrayAddCriteria([]));
      dispatch(pushSelectedChipArray([]));
      dispatch(pushClearFilterArray([]));
      dispatch(pushShowCard(false));
      dispatch(pushRestrictValue(false));
      dispatch(pushCancelEvent(false));
      dispatch(pushApplyEvent(false));
      dispatch(pushConditionalTab(true));
    }
  }, selectedAccount) : /*#__PURE__*/React.createElement(StyledLink, {
    color: "initial"
  }, selectedAccount));
};

export default withRouter(RecommendationBreadCrumbs);